
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Swiftdezireonrentinpune() {



    const cardData =
    {
        keyword: 'Swift Dzire on Rent in Pune  ',
        heading: 'Vedant Travels: Swift Dzire on Rent in Pune  ',
        headingDescription: 'Vedant Travels offers the Swift Dzire on rent in Pune, a compact and fuel-efficient car perfect for short trips, business travel, and family outings. With its comfortable seating, smooth ride, and great mileage, the Swift Dzire is an ideal choice for both city commuting and long-distance travel. Whether you are exploring Pune or going on a road trip, the Swift Dzire provides a reliable and affordable travel solution.',

        top: 'Top Places to Visit in Pune with Vedant Travels',

       "topPlaces": [
        {
            "title": "Shaniwar Wada",
            "description": "A historic fort that was once the residence of the Peshwa rulers, Shaniwar Wada is a must-visit for history enthusiasts. The fort features impressive Maratha architecture and offers an engaging light-and-sound show that brings its fascinating history to life."
        },
        {
            "title": "Aga Khan Palace",
            "description": "Built in 1892, the Aga Khan Palace is not only a beautiful structure but also a significant historical site. It was used as a prison during the freedom struggle, and Mahatma Gandhi and his associates were held here. The palace is surrounded by lush gardens, providing a peaceful atmosphere for reflection."
        },
        {
            "title": "Sinhagad Fort",
            "description": "Located 35 km from Pune, Sinhagad Fort is a popular destination for trekkers and history lovers. The fort offers stunning views of the surrounding valleys and is known for its role in Maratha history. It’s a great place for those seeking adventure and historical exploration."
        },
        {
            "title": "Osho Ashram",
            "description": "Situated in Koregaon Park, the Osho Ashram is a globally recognized meditation and spiritual retreat center. Visitors can participate in a variety of meditation sessions and spiritual workshops, making it an ideal spot for relaxation and inner peace."
        },
        {
            "title": "Raja Dinkar Kelkar Museum",
            "description": "The Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts, including sculptures, musical instruments, and daily-use items from different historical periods. It’s a fascinating stop for anyone interested in India’s cultural heritage."
        },
        {
            "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
            "description": "A beautiful Japanese-inspired garden located in Pune, this garden is perfect for a relaxing stroll. With lush greenery, vibrant flowers, and serene ponds, it offers a peaceful escape from the busy city life."
        },
        {
            "title": "Pashan Lake",
            "description": "Pashan Lake is a serene spot, perfect for nature lovers and birdwatching enthusiasts. Surrounded by lush greenery, it provides a quiet environment for photography, walks, and peaceful reflection."
        },
        {
            "title": "Bund Garden",
            "description": "Bund Garden is a riverside park ideal for a relaxing walk, boating, or picnicking. The tranquil atmosphere and natural beauty make it a lovely spot to unwind and enjoy time with family or friends."
        },
        {
            "title": "Saras Baug",
            "description": "Saras Baug is a popular temple complex in Pune, known for its beautiful Ganesha temple and peaceful gardens. It’s a great place to enjoy a leisurely walk, relax in the gardens, or simply seek spiritual solace."
        },
        {
            "title": "Fergusson College",
            "description": "One of Pune’s oldest and most prestigious educational institutions, Fergusson College is known for its colonial-era architecture and rich academic history. It’s a beautiful campus to explore, showcasing Pune’s educational legacy and architectural beauty."
        }
    ],
"services": [
    {
        "name": "Swift Dzire on Rent in Pune",
        "description": "Vedant Travels offers Swift Dzire on rent in Pune, providing an affordable and comfortable option for both local and outstation travel. Our well-maintained cars ensure a smooth and stress-free journey."
    },
    {
        "name": "Dzire on Rent for Outstation",
        "description": "Looking for a Dzire on rent for outstation trips? Vedant Travels provides Swift Dzire rentals for long-distance travel, ensuring you have a comfortable and budget-friendly ride for your journey."
    },
    {
        "name": "Per Km Rate for Swift Dzire Cab",
        "description": "Vedant Travels offers competitive per km rates for Swift Dzire cabs in Pune. Enjoy an affordable and comfortable journey with our well-maintained Swift Dzire vehicles."
    },
    {
        "name": "Dzire Per Km Rate for Cab Booking",
        "description": "Book a Swift Dzire cab with Vedant Travels and enjoy transparent pricing. Our per km rates for Dzire cabs ensure you get the best value for your money."
    },
    {
        "name": "Swift Dzire Per Km Rate in Pune",
        "description": "The per km rate for a Swift Dzire cab in Pune with Vedant Travels is affordable and competitive. Our pricing ensures that you travel in comfort and within your budget."
    },
    {
        "name": "Swift Dzire Rent Per Km Rate for Outstation",
        "description": "Vedant Travels offers affordable rent per km rates for Swift Dzire cabs on outstation journeys. Enjoy a comfortable ride at competitive prices for long-distance trips."
    },
    {
        "name": "Swift Dzire Rent Per Day",
        "description": "Rent a Swift Dzire per day with Vedant Travels for your local or outstation trips in Pune. Our daily rental services provide comfort and convenience for all your travel needs."
    },
    {
        "name": "Swift Dzire Taxi Rate Per Km",
        "description": "Vedant Travels offers a transparent taxi rate per km for Swift Dzire cabs. Enjoy a smooth and budget-friendly ride with no hidden charges."
    },
    {
        "name": "Pune to Mahabaleshwar Swift Dzire Tour",
        "description": "Rent a Swift Dzire for your Pune to Mahabaleshwar tour with Vedant Travels. Our well-maintained vehicles ensure a comfortable and scenic journey to this popular destination."
    },
    {
        "name": "Pune to Shirdi Swift Dzire Cab",
        "description": "For a hassle-free and comfortable ride from Pune to Shirdi, rent a Swift Dzire from Vedant Travels. Our cabs are perfect for your pilgrimage trip to Shirdi, offering comfort and convenience."
    },
    {
        "name": "Pune to Lonavala Swift Dzire Cab",
        "description": "Rent a Swift Dzire for your Pune to Lonavala journey with Vedant Travels. Our well-maintained vehicles ensure a smooth and comfortable ride to this scenic hill station."
    },
    {
        "name": "Pune to Ashtavinayak Swift Dzire Cab",
        "description": "Vedant Travels offers Swift Dzire cabs for your Pune to Ashtavinayak journey. Enjoy a comfortable and convenient ride while visiting the famous Ashtavinayak temples."
    },
    {
        "name": "Pune to Mumbai Airport Swift Dzire Cab",
        "description": "Rent a Swift Dzire for a smooth ride from Pune to Mumbai Airport. Vedant Travels provides reliable and affordable taxi services with well-maintained vehicles to ensure timely arrivals."
    },
    {
        "name": "Pune to Goa Swift Dzire Hire",
        "description": "For your Pune to Goa trip, Vedant Travels offers Swift Dzire for hire. Enjoy a comfortable and spacious ride as you travel to the beautiful coastal city of Goa."
    },
    {
        "name": "Pune to Bhimashankar Swift Dzire Taxi",
        "description": "Choose Vedant Travels for your Pune to Bhimashankar trip with a Swift Dzire taxi. Our vehicles offer comfort and reliability for this spiritual journey to Bhimashankar Temple."
    },
    {
        "name": "Swift Dzire Taxi for Outstation",
        "description": "For outstation travel, Vedant Travels offers Swift Dzire taxis. Our well-maintained vehicles ensure a comfortable and budget-friendly ride for long-distance trips."
    },
    {
        "name": "Swift Dzire Cab for Corporate Employees",
        "description": "Vedant Travels offers Swift Dzire cabs for corporate employees, providing comfortable and timely transport for business meetings, conferences, and corporate events."
    },
    {
        "name": "Cab Services for Corporate Events",
        "description": "Need a Swift Dzire for a corporate event? Vedant Travels offers reliable cab services for corporate events, ensuring smooth and timely transportation for all your business needs."
    }
],


"tableData": [
    ["Swift Dzire on Rent in Pune", "Dzire on Rent for Outstation"],
    ["Per Km Rate for Swift Dzire Cab", "Dzire Per Km Rate for Cab Booking"],
    ["Swift Dzire Per Km Rate in Pune", "Swift Dzire Rent Per Km Rate for Outstation"],
    ["Swift Dzire Rent Per Day", "Swift Dzire Taxi Rate Per Km"],
    ["Pune to Mahabaleshwar Swift Dzire Tour", "Pune to Shirdi Swift Dzire Cab"],
    ["Pune to Lonavala Swift Dzire Cab", "Pune to Ashtavinayak Swift Dzire Cab"],
    ["Pune to Mumbai Airport Swift Dzire Cab", "Pune to Goa Swift Dzire Hire"],
    ["Pune to Bhimashankar Swift Dzire Taxi", "Swift Dzire Taxi for Outstation"],
    ["Swift Dzire Cab for Corporate Employees", "Cab Services for Corporate Events"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of punctuality. Whether you need the Swift Dzire for a business trip, family outing, or an airport transfer in Pune, we ensure timely pickup and drop-off, allowing you to travel with ease and convenience."
    },
    {
      "WhyChooseheading": "Comfortable and Compact Vehicle",
      "WhyChoosedescription": "The Swift Dzire is known for its comfort and compact size, making it an ideal choice for city travel and short trips. With a spacious cabin, good legroom, and excellent air conditioning, it ensures a smooth and pleasant ride, even in crowded city traffic."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our professional drivers are well-trained and familiar with Pune’s roads. They ensure safe and efficient driving, taking you to your destination on time while providing courteous and friendly service throughout the journey."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers affordable pricing for Swift Dzire rentals in Pune with a transparent cost structure. There are no hidden charges, and we provide a clear breakdown of the rental charges upfront, so you know exactly what you’re paying for."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. The Swift Dzire is regularly maintained and equipped with essential safety features like airbags, seat belts, and modern braking systems. Our drivers strictly adhere to safety protocols to ensure a secure and comfortable ride."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether it’s an early morning flight or a late-night return, Vedant Travels is available around the clock for Swift Dzire rentals. You can book your cab anytime, and our customer service team is ready to assist with your booking and travel needs."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking a Swift Dzire with Vedant Travels is simple and quick. You can book online via our website or mobile app, or call our customer service team for personalized assistance. We strive to make your booking process as smooth as possible."
    },
    {
      "WhyChooseheading": "Customizable Travel Packages",
      "WhyChoosedescription": "Whether you're looking for a one-way trip, a sightseeing tour, or a round-trip journey, we offer flexible and customizable packages for Swift Dzire rentals. Share your requirements, and we will tailor the service to meet your travel needs."
    }
  ]

    }



    const faqData = [
        {
            id: 1,
            question: 'How can I rent a Swift Dzire in Pune?',
            answer: 'You can easily rent a Swift Dzire by booking online through our website or mobile app. Alternatively, you can call our customer service team, and they will assist you with your booking.',
        },
        {
            id: 2,
            question: 'What is the seating capacity of the Swift Dzire?',
            answer: 'The Swift Dzire can comfortably seat up to 4 passengers with ample space for luggage. It’s an ideal vehicle for small groups, families, or solo travelers.',
        },
        {
            id: 3,
            question: 'Is the Swift Dzire suitable for long-distance travel?',
            answer: 'Yes, the Swift Dzire is perfect for both city travel and long-distance trips. It offers a comfortable and smooth ride, making it a great choice for road trips to nearby cities or destinations.',
        },
        {
            id: 4,
            question: 'What payment methods are accepted for Swift Dzire rentals?',
            answer: 'We accept various payment methods, including cash, credit/debit cards, and online payments via our mobile app. We make the payment process as convenient as possible for you.',
        },
        {
            id: 5,
            question: 'Can I rent a Swift Dzire for a one-way trip from Pune to Mumbai or other cities?',
            answer: 'Yes, you can rent a Swift Dzire for a one-way trip from Pune to Mumbai or other cities. Just let us know your trip details, and we will arrange the rental accordingly.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for Swift Dzire rentals?',
            answer: 'Any additional charges, such as toll fees, extra waiting time, or fuel costs, will be clearly communicated to you during the booking process. We believe in providing transparent pricing with no hidden fees.',
        },
        {
            id: 7,
            question: 'Can I use the Swift Dzire for sightseeing in Pune?',
            answer: 'Yes, the Swift Dzire is great for sightseeing around Pune. Whether you want to visit historical sites like Shaniwar Wada or explore nearby hill stations, we can customize your sightseeing trip based on your preferences.',
        },
        {
            id: 8,
            question: 'What is the luggage capacity of the Swift Dzire?',
            answer: 'The Swift Dzire has a decent boot space that can accommodate standard luggage. If you have additional or special luggage requirements, please inform us during booking, and we will make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel with the Swift Dzire?',
            answer: 'Yes, we offer Swift Dzire rentals for corporate travel. Whether it’s for meetings, events, or conferences, we can provide a professional and comfortable vehicle for your business needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Swift Dzire rental in Pune?',
            answer: 'Vedant Travels is known for its reliable service, well-maintained vehicles, professional drivers, and affordable rates. We ensure you have a comfortable, safe, and hassle-free experience when renting a Swift Dzire with us.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Arvind Patil",
            title: "Family Traveler",
            quote: "I rented a Swift Dzire for a weekend getaway with my family in Pune. The vehicle was clean, comfortable, and perfect for our trip. The driver was punctual and very friendly. I highly recommend Vedant Travels for anyone looking to rent a car in Pune.",
            rating: 5,
        },
        {
            name: "Ms. Priya Joshi",
            title: "Business Traveler",
            quote: "I used Vedant Travels for a business trip, and the Swift Dzire was perfect for my needs. The vehicle was in excellent condition, and the driver was professional. I’ll definitely consider them for my future travels.",
            rating: 5,
        },
    ];
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Pune",
  "image": "https://vedanttravels.in/assets/images/swift-dzire-on-rent-in-pune.jpg",
  "description": "Rent Swift Dzire in Pune with Vedant Travels for a budget-friendly, comfortable, and fuel-efficient ride. Ideal for city travel, airport transfers, and outstation trips with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "4600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1799",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/swift-dzire-on-rent-in-pune"
  }
};



      
   
      

    return (
        <div>
        <Helmet>
  <title>Swift Dzire on Rent in Pune | Affordable & Comfortable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Rent Swift Dzire in Pune with Vedant Travels for a budget-friendly, comfortable, and fuel-efficient ride. Ideal for city travel, airport transfers, and outstation trips with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Swift Dzire on Rent in Pune, Dzire Cab Pune, Rent Dzire Car Pune, Dzire Taxi Hire Pune, Sedan on Rent Pune, Budget Car Rental Pune, Swift Dzire for Outstation Pune, Dzire with Driver Pune, Vedant Travels Dzire, Online Dzire Booking Pune, Comfortable Sedan Rental Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Swiftdezireonrentinpune;